// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/extras/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  width: 100%;
  position: relative;
}
.profile-container__header {
  height: 180px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  padding: 16px;
  position: relative;
  margin-bottom: 60px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.profile-container__header--avatar {
  position: absolute;
  bottom: -45px;
  left: 30px;
}
.profile-container__user {
  margin-left: 150px;
  margin-top: -40px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 30px;
}
.profile-container__user--name {
  font-size: 24px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Profile/Profile.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;AACR;AACQ;EACI,kBAAA;EACA,aAAA;EACA,UAAA;AACZ;AAGI;EACI,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AADR;AAGQ;EACI,eAAA;EACA,gBAAA;AADZ","sourcesContent":[".profile-container {\n    width: 100%;\n    position: relative;\n\n    &__header {\n        height: 180px;\n        background-image: url('../../../assets//extras/background.png');\n        background-repeat: no-repeat;\n        background-position: top;\n        background-size: cover;\n        padding: 16px;\n        position: relative;\n        margin-bottom: 60px;\n        border-top-left-radius: 4px;\n        border-top-right-radius: 4px;\n\n        &--avatar {\n            position: absolute;\n            bottom: -45px;\n            left: 30px;\n        }\n    }\n\n    &__user {\n        margin-left: 150px;\n        margin-top: -40px;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        margin-bottom: 30px;\n\n        &--name {\n            font-size: 24px;\n            font-weight: 600;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
